import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll to the top of the page whenever the route (pathname) changes.
 * Without this, navigating between pages keeps the previous scroll position —
 * e.g. clicking the cart icon while scrolled down opens /cart at the footer.
 * Must be rendered inside <Router>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
